<template>
    <a class="home-collection-gallery" :href="link" :style="styles">
        <transition name="fade">
            <super-image
                class="background"
                :src="cleanImages[idx]"
                color="#f1f1f1"
                fill-space
                :key="idx"
            />
        </transition>
        <img
            v-for="url in cleanImages"
            :src="url"
            class="preload"
            style="display: none;"
        />
    </a>
</template>

<script>
import mousePos from '../mixins/mousePos'
import _clamp from 'lodash/clamp'

export default {
    mixins: [mousePos],
    props: {
        images: Array,
        link: String,
        aspect: [String, Number]
    },
    computed: {
        styles() {
            const aspect = parseInt(this.aspect)
            if (aspect) {
                return {
                    paddingBottom: `${aspect}%`
                }
            }
        },
        idx() {
            const idx = Math.floor(this.mouseX * this.cleanImages.length) || 0
            return _clamp(idx, 0, this.cleanImages.length - 1)
        },
        cleanImages() {
            const images = this.images || []
            return images.map(s => s.trim()).filter(Boolean)
        }
    }
}
</script>

<style lang="scss">
@import 'src/scss/mixins';

.home-collection-gallery {
    position: relative;
    display: block;

    // transition
    .fade-enter-active,
    .fade-leave-active {
        transition: 100ms opacity;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
}
</style>
